package hk.com.vr360_demo2.webapp.core.net

import hk.com.vr360_demo2.webapp.core.net.common.ResponseInfo

//import com.hse777.hse777.core.event.AppEvent
//import com.hse777.hse777.core.hook.EventManager

//import com.hse777.hse777.store.AppTypes


object BusinessErrorHandler {
    fun handleError(response: ResponseInfo<*>) {
        return when (response.code.toString()) {
            HttpCodeConstant.NOLOGIN -> {
               // EventManager.post(AppEvent(AppTypes.Intent.Logout))
            }

            HttpCodeConstant.KICKEDOUT -> {
               // EventManager.post(AppEvent(AppTypes.Intent.Logout))
            }

            else -> {}
        }
    }
}

